import React from "react";
import { Skeleton } from "antd";

const SidebarSkeleton = () => {
  return (
    <aside className="col-xl-4 col-xxl-3">
      <div>
        <div className="offcanvas-xl offcanvas-end">
          <div className="offcanvas-header">
            <Skeleton.Input style={{ width: 200 }} active size="large" />
            <Skeleton.Button
              shape="circle"
              style={{ marginLeft: "auto" }}
              active
              size="default"
            />
          </div>
          <div className="offcanvas-body flex-column p-3 p-xl-0">
            <form className="rounded-3 shadow">
              <div className="card card-body rounded-0 rounded-top p-4">
                <Skeleton active title={false} paragraph={{ rows: 1 }} />
                <Skeleton.Input style={{ width: "100%" }} active />
              </div>

              <hr className="my-0" />

              <div className="card card-body rounded-0 p-4">
                <Skeleton active title={false} paragraph={{ rows: 1 }} />
                <div>
                  {Array.from({ length: 5 }).map((_, index) => (
                    <Skeleton
                      key={index}
                      active
                      title={false}
                      paragraph={{ rows: 1 }}
                    />
                  ))}
                </div>
              </div>

              <hr className="my-0" />

              <div className="card card-body rounded-0 p-4">
                <Skeleton active title={false} paragraph={{ rows: 1 }} />
                <Skeleton.Input style={{ width: "100%" }} active />
              </div>

              <hr className="my-0" />

              <div className="card card-body rounded-0 p-4">
                <Skeleton active title={false} paragraph={{ rows: 1 }} />
                <div>
                  {Array.from({ length: 5 }).map((_, index) => (
                    <Skeleton
                      key={index}
                      active
                      title={false}
                      paragraph={{ rows: 1 }}
                    />
                  ))}
                </div>
              </div>

              <hr className="my-0" />

              <div className="card card-body rounded-0 p-4">
                <Skeleton active title={false} paragraph={{ rows: 1 }} />
                <div>
                  {Array.from({ length: 5 }).map((_, index) => (
                    <Skeleton
                      key={index}
                      active
                      title={false}
                      paragraph={{ rows: 1 }}
                    />
                  ))}
                </div>
              </div>

              <hr className="my-0" />

              <div className="card card-body rounded-0 p-4">
                <Skeleton active title={false} paragraph={{ rows: 1 }} />
                <Skeleton.Input style={{ width: "100%" }} active />
              </div>

              <hr className="my-0" />
            </form>
          </div>
          <div className="d-flex justify-content-between p-2 p-xl-0 mt-xl-4">
            <Skeleton.Button
              shape="round"
              style={{ width: "45%" }}
              active
              size="default"
            />
            <Skeleton.Button
              shape="round"
              style={{ width: "45%" }}
              active
              size="default"
            />
          </div>
        </div>
      </div>
    </aside>
  );
};

export default SidebarSkeleton;
